import {
    IRealityCheckPresenter,
    IShowRealityCheckOptions,
    IShowRealityCheckResult
} from "./reality-check-presenter.interface";
import {IModalDialogHandler} from "../../../dialog/dialog.service.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";

export abstract class RealityCheckDialogPresenterBase implements IRealityCheckPresenter {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }

    protected abstract _showDialog(options: IShowRealityCheckOptions, onDialogClosed: () => void): Promise<IModalDialogHandler>;

    private _dialogHandler: IModalDialogHandler | null = null;
    private _isForceClosed = false;

    forceClose() {
        if(this._dialogHandler) {
            this._isForceClosed = true;
            this._dialogHandler.close();
            this._dialogHandler = null;
        }
    }

    dispose(): void {
        this.forceClose();
    }

    async showRealityCheck(options: IShowRealityCheckOptions): Promise<IShowRealityCheckResult> {
        return new Promise<IShowRealityCheckResult>(async (resolve) => {
            this._dialogHandler = await this._showDialog(options, () => {
                this._dialogHandler = null;
                resolve({
                    isForceClosed: this._isForceClosed
                });
                this._isForceClosed = false;
            })
        });
    }
}